<template>
  <section class="content">
    <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
              <!-- <div class="p-field p-col-12 p-md-2">
                <label for="toDate">Store</label>
                <Dropdown
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select Account"
                  :disabled="true"
                />
            </div> -->

            <div class="p-field p-col-12 p-md-1 p-mt-5">
                 <Button @click.prevent="settelAccount()"
                 class="p-button-raised" label="Settel" icon="pi pi-check"/>
                  <!-- <button type="submit" style="margin-left:10px" v-if="this.inventoryInOutStoreLists.length > 0"  @click.prevent="reset"
                 class="btn btn-info pull-left">Reset</button> -->
            </div>
          </div>
        </form>
    </div>
  </div>
  </section>
</template>
<script>
import Button from 'primevue/button'
export default {
  name: 'inventoryInOutStoreLists',
  data() {
    return {
      loading: false,
      id: '0',
      filters: {}
    }
  },
  methods: {
    async settelAccount() {
      this.loading = true
      let resp = await this.$store.dispatch('saveSettelAccount')
      this.loading = false
      this.inventoryInOutStoreLists = resp
    }
  },
  components: {
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// fiscalYearSettlement.vue?35a5b84e